// lib
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ClickAwayListener, Paper, Popper as LibPopper } from "@material-ui/core";
// src

const Tooltip = ({
  // from parent
  main,
  render,
  placement,
  className,
  modifiers,
  AnchorType,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 27) handleClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <>
      <AnchorType className="tooltip-anchor" role="button" onClick={handleOpen}>
        {main}
      </AnchorType>
      <LibPopper
        className={className}
        anchorEl={anchorEl}
        open={open}
        placement={placement}
        hidebackdrop="true"
        modifiers={modifiers}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={3}>{render({ handleClose })}</Paper>
        </ClickAwayListener>
      </LibPopper>
    </>
  );
};
Tooltip.propTypes = {
  // from parent
  main: PropTypes.node.isRequired,
  render: PropTypes.func.isRequired,
  placement: PropTypes.string,
  className: PropTypes.string,
  modifiers: PropTypes.object,
  AnchorType: PropTypes.string,
};

Tooltip.defaultProps = {
  placement: "top-start",
  className: "",
  modifiers: {},
  AnchorType: "div",
};

export default Tooltip;
